import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  systemInfo: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: 'systemInfo',
  initialState,
  reducers: {
    getSystemInfoSuccess: (state, {payload}) => {
      state.systemInfo = payload;
      state.loading = false;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getSystemInfo = ({ accessToken }) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoading());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-systemInfo`,
        { headers }
      );
      dispatch(slice.actions.getSystemInfoSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};
